import * as moment from 'moment'
import * as constants from '../static/constants'
import * as interfaces from '../static/interfaces'
import { ISelectedGuests } from './reservation'
import { getDatesFromCookieDateRange, getSearchFiltersCookie } from './searchFiltersCookie'

interface IInitialReservationParams {
  reservationStorageData: interfaces.IReservationStorageData
  initialDatesFromUrl: moment.Moment[]
  initialGuestsFromUrl: ISelectedGuests | null
  searchFiltersCookie: ReturnType<typeof getSearchFiltersCookie>
}

export const resolveInitialReservationParams = ({
  reservationStorageData,
  initialDatesFromUrl,
  initialGuestsFromUrl,
  searchFiltersCookie,
}: IInitialReservationParams) => {
  const storedDates = reservationStorageData?.initParams?.dates
  let initialDates = storedDates ? storedDates.map(date => moment(date)) : null
  if (initialDates === null) {
    initialDates = initialDatesFromUrl
  }
  if (initialDates.length === 0 && storedDates === undefined && searchFiltersCookie?.dateRange) {
    initialDates = getDatesFromCookieDateRange(searchFiltersCookie.dateRange)
  }

  const initialGuests =
    reservationStorageData?.initParams?.guests ||
    initialGuestsFromUrl ||
    searchFiltersCookie?.guests ||
    constants.DEFAULT_SEARCH_FILTER_GUESTS

  return { dates: initialDates, guests: initialGuests }
}
